module.exports = __webpack_public_path__ + "img/angles-right.55acc4aa.svg";